import axios from "axios";

import { loadProgressBar } from "components/ProgressBar";
import { getToken } from "./token";

const apiV1BaseURL = process.env.REACT_APP_API_BASE_URL;

const privateInstance = axios.create({
  baseURL: `${apiV1BaseURL}/`,
  withCredentials: false,
  headers: {
    "Content-Type": "application/json",
  },
  maxRedirects: 0,
});

const publicInstance = axios.create({
  baseURL: `${apiV1BaseURL}/`,
  withCredentials: false,
  headers: {
    "Content-Type": "application/json",
  },
});

export const getRequest = async (axiosInstance, path, params = {}) => {
  return await axiosInstance.get(path, { params });
};

export const postRequest = async (
  axiosInstance,
  path,
  params,
  headers = null
) => {
  return await axiosInstance.post(path, params, { headers });
};

export const putRequest = async (axiosInstance, path, params = {}, headers) => {
  return await axiosInstance.put(path, params, { headers });
};

export const deleteRequest = async (axiosInstance, path, params = {}) => {
  return await axiosInstance.delete(path, params);
};

export const setLocalToken = (authToken) => {
  const token = authToken || getToken();
  privateInstance.defaults.headers["Authorization"] = `Bearer ${token}`;
};

setLocalToken();

export const privateRequest = {
  get: (path, params) => getRequest(privateInstance, path, params),
  post: (path, params, headers = null) =>
    postRequest(privateInstance, path, params, headers),
  put: (path, params, headers = null) =>
    putRequest(privateInstance, path, params, headers),
  delete: (path, params) => deleteRequest(privateInstance, path, params),
  setLocalToken,
};

const requestHandler = async (instance, path, params, request) => {
  return await request(instance, path, params);
};

const request = {
  get: async (path, params) =>
    await requestHandler(publicInstance, path, params, getRequest),
  post: async (path, params) =>
    await requestHandler(publicInstance, path, params, postRequest),
  put: async (path, params) =>
    await requestHandler(publicInstance, path, params, putRequest),
  delete: async (path, params) =>
    await requestHandler(publicInstance, path, params, deleteRequest),
};

const onSuccess = (response) => {
  if (response.data.redirect_url) {
    window.location.href = response.data.redirect_url;
    return;
  }

  return response;
};

const onError = (error) => {
  if (error.response.data && error.response.data.error) {
    throw new Error(error.response.data.error);
  }

  throw error;
};

loadProgressBar(
  {
    showSpinner: false,
  },
  [privateInstance, publicInstance],
  onSuccess,
  onError
);

export default request;
